import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { BaseSafeFormView, BaseView } from '@/components/base'
import { FeatureType } from '@/domain/settings/settingTypes'
import {
  ResetValidationByFeatureOnRouteEntry,
  useValidationsByFeatureStore,
  ValidationByFeatureFooter,
  ValidationByFeatureHeader,
  ValidationByFeatureValidationsList,
} from '@/features/validations-by-feature'

export interface ValidationsByFeatureParams {
  feature?: FeatureType
}

export default function ValidationsByFeature() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  // Get feature from URL search params
  const featureInParams = searchParams.get('feature') as FeatureType | undefined
  const featureInStore = useValidationsByFeatureStore((s) => s.feature)

  useEffect(() => {
    if (!featureInStore && !featureInParams) {
      navigate('/dashboard', { replace: true })
    }
  }, [featureInStore, featureInParams, navigate])

  return (
    <>
      <ResetValidationByFeatureOnRouteEntry feature={featureInParams} />
      <BaseView flex={1} bgColor="background.screen" className="h-full">
        <BaseView gap={32}>
          <ValidationByFeatureHeader />
          {!!featureInStore && (
            <BaseView flex={1}>
              <ValidationByFeatureValidationsList />
            </BaseView>
          )}
        </BaseView>

        <BaseView
          style={{
            position: 'absolute',
            bottom: 50,
            width: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <ValidationByFeatureFooter />
        </BaseView>
      </BaseView>
    </>
  )
}
